import React from 'react'
import UserHeader from './UserHeader'
import LifeStyleFamilyForm from './LifeStyleFamilyForm'
import UserFooter from './UserFooter'

function LifeStyleFamily() {
  return (
    <div className="formBody">
        <UserHeader/>
        <LifeStyleFamilyForm/>
        <UserFooter/>
    </div>
  )
}

export default LifeStyleFamily